@if (icon || showClear) {
  <span
    [class.p-input-icon-left]="isInputIconLeft && icon"
    [class.p-input-icon-right]="!isInputIconLeft && icon"
    class="w-full relative inline-block">
    @if (!isInputIconLeft) {
      <ng-template [ngTemplateOutlet]="clearIconTemplate"></ng-template>
    }

    @if (icon) {
      <i [class]="icon"></i>
    }

    @if (isInputIconLeft) {
      <ng-template [ngTemplateOutlet]="clearIconTemplate"></ng-template>
    }

    <ng-template [ngTemplateOutlet]="inputTemplate"></ng-template>

    <ng-template #clearIconTemplate>
      @if (value && showClear) {
        <i
          class="pi pi-times cursor-pointer hover:frm-color-blue-light absolute top-50 -mt-2 right-0 frm-input-text-clear-icon"
          [ngStyle]="{
            'font-size.rem': fontSizeIconClear,
            'margin-right.rem': !isInputIconLeft && icon ? 2.5 * fontSizeIconClear : 1
          }"
          (click)="clearValue()"></i>
      }
    </ng-template>
  </span>
} @else {
  <ng-template [ngTemplateOutlet]="inputTemplate"></ng-template>
}

<ng-template #inputTemplate>
  <input
    #input
    [type]="type"
    pInputText
    [ngModel]="value"
    (ngModelChange)="changeText($event)"
    (focus)="onFocus.emit($event)"
    (blur)="onBlur.emit($event)"
    [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
    [placeholder]="placeholder"
    [name]="name"
    [style]="style"
    [ngStyle]="{ 'padding-right.rem': showClear && value ? (!isInputIconLeft && icon ? 4 : 2.5) : null }"
    [disabled]="disabled"
    [autocomplete]="autocomplete"
    [autofocus]="autofocus"
    [minLength]="minLength"
    [maxlength]="maxLength" />
</ng-template>
